import Swiper from 'swiper/bundle'
import { debounce } from './utility.js';

// オーバーレイの表示切り替え
const setupClickToggle = () => {
    document.querySelectorAll('.js-click').forEach((button) => {
        button.addEventListener('click', function() {
            const targetId = button.getAttribute('data-click');
            const targetElement = document.getElementById(targetId);

            if (targetId.includes('header')) {
                document.querySelectorAll('.js-click').forEach((otherButton) => {
                    const otherTargetId = otherButton.getAttribute('data-click');
                    const otherTargetElement = document.getElementById(otherTargetId);

                    if (otherTargetId.includes('header') && targetElement !== otherTargetElement) {
                        otherButton.classList.remove('is-clicked');
                        otherTargetElement.classList.remove('is-clicked');
                    }
                });
                this.classList.toggle('is-clicked');
                targetElement.classList.toggle('is-clicked');
            } else if (targetId.includes('hamburger')) {
                document.body.classList.toggle('on-hamburger');
            } else if (targetId.includes('case')) {
                document.querySelectorAll('.js-click').forEach((otherButton) => {
                    const otherTargetId = otherButton.getAttribute('data-click');
                    const otherTargetElement = document.getElementById(otherTargetId);

                    if (otherTargetId.includes('case') && targetElement !== otherTargetElement) {
                        otherButton.classList.remove('is-clicked');
                        otherTargetElement.classList.remove('is-clicked');
                    }
                });
                this.classList.toggle('is-clicked');
                targetElement.classList.toggle('is-clicked');
            } else {
                this.classList.toggle('is-clicked');
                targetElement.classList.toggle('is-clicked');
            }
        });
    });
};

//モーダルｄの表示切り替え
const setupModalToggle = () => {
    document.querySelectorAll('.js-modal').forEach((button) => {
        button.addEventListener('click', () => {
            const targetId = button.getAttribute('data-modal');
            const targetElement = document.getElementById(targetId);
            targetElement.classList.toggle('is-active');
            document.body.classList.toggle(`on-modal`);
        });
    });
};

const setupIndexToggle = () => {
    document.querySelectorAll('.js-index-button').forEach((button) => {
        button.addEventListener('click', () => {
            const panel = button.closest(".js-index");
            const panelIsOpened = panel.getAttribute("aria-hidden");

            if (panelIsOpened === "true") {
                panel.setAttribute("aria-hidden", false);
            } else {
                panel.setAttribute("aria-hidden", true);
            }
        });
    });
};

//faq toggle
const faqToggle = () => {
    document.querySelectorAll('.js-faq-button').forEach((button) => {
        button.addEventListener('click', () => {
            const panel = button.closest(".js-faq");
            const panelIsOpened = panel.getAttribute("aria-hidden");

            if (panelIsOpened === "true") {
                panel.setAttribute("aria-hidden", false);
            } else {
                panel.setAttribute("aria-hidden", true);
            }
        });
    });
};



// case accordion toggle
const caseAccordionToggle = () => {
    const accordionButtons = document.querySelectorAll('.js-case-accordion__button');

    if (accordionButtons.length === 0) {
        console.warn('アコーディオンボタンが見つかりません');
        return;
    }

    accordionButtons.forEach((button) => {
        // 既存のイベントリスナーを削除（重複防止）
        button.removeEventListener('click', handleAccordionClick);
        button.addEventListener('click', handleAccordionClick);
    });

    console.log(`アコーディオンボタン: ${accordionButtons.length}個初期化完了`);
};

// アコーディオンボタンクリック時の処理
const handleAccordionClick = (e) => {
    const button = e.currentTarget;
    const panel = button.closest('.js-case-accordion');

    if (!panel) {
        console.warn('アコーディオンパネルが見つかりません');
        return;
    }

    const isExpanded = panel.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
        panel.setAttribute('aria-expanded', 'false');
        console.log('アコーディオンを閉じました');
    } else {
        panel.setAttribute('aria-expanded', 'true');
        console.log('アコーディオンを開きました');
    }
};

// case reset button
const caseResetToggle = () => {
    // DOM要素の存在を確認する関数
    const waitForElement = (selector, timeout = 3000) => {
        return new Promise((resolve, reject) => {
            const element = document.querySelector(selector);
            if (element) {
                resolve(element);
                return;
            }

            const observer = new MutationObserver((mutations, obs) => {
                const element = document.querySelector(selector);
                if (element) {
                    obs.disconnect();
                    resolve(element);
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            setTimeout(() => {
                observer.disconnect();
                reject(new Error(`Element ${selector} not found within ${timeout}ms`));
            }, timeout);
        });
    };

    // 要素が存在するかチェック
    const resetButtons = document.querySelectorAll('.js-case-reset');

    if (resetButtons.length === 0) {
        // 要素が見つからない場合、少し待ってから再試行
        setTimeout(() => {
            const retryButtons = document.querySelectorAll('.js-case-reset');
            if (retryButtons.length > 0) {
                console.log('絞り込み解除ボタンを遅延検出しました');
                setupResetButtonListeners(retryButtons);
            } else {
                console.warn('絞り込み解除ボタンが見つかりません - ページに要素が存在しない可能性があります');
            }
        }, 100);
        return;
    }

    setupResetButtonListeners(resetButtons);
    console.log(`絞り込み解除ボタン: ${resetButtons.length}個初期化完了`);
};

// リセットボタンのイベントリスナーを設定する関数
const setupResetButtonListeners = (buttons) => {
    buttons.forEach((button) => {
        // 既存のイベントリスナーを削除（重複防止）
        button.removeEventListener('click', handleResetClick);
        button.addEventListener('click', handleResetClick);
    });
};

// リセットボタンクリック時の処理
const handleResetClick = (e) => {
    e.preventDefault();
    console.log('絞り込み解除ボタンがクリックされました');

    // すべてのALLラジオボタンを選択
    const radioIds = ['category01', 'employee01', 'area01', 'task01'];
    let resetCount = 0;

    radioIds.forEach((id) => {
        const radio = document.getElementById(id);
        if (radio) {
            radio.checked = true;
            resetCount++;
            console.log(`${id} をリセットしました`);
        } else {
            console.warn(`${id} が見つかりません`);
        }
    });

    console.log(`${resetCount}個のフィルターをリセットしました`);
};


// スワイパー
const setupSwiper = () => {
    const swiperHeroConfig = {
        effect: 'fade', // slide | fade | cube | coverflow | flip | creative | cards
        fadeEffect: {
            crossFade: true,
        },
        allowTouchMove: true,

        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: false,

        // loop: true,
        // loopAdditionalSlides: 2,
        speed: 1200,

        autoplay: {
            delay: 7000,
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets' // 'bullets' | 'fraction' | 'progressbar'
        },

        // navigation: {
        // 	prevEl: '.swiper-button-prev',
        // 	nextEl: '.swiper-button-next',
        // },

        // breakpoints: {
        //     768: {
        //     }
        // }
    }

    const swiperNewsConfig = {
        effect: 'slide', // slide | fade | cube | coverflow | flip | creative | cards
        fadeEffect: {
            crossFade: true,
        },
        allowTouchMove: true,

        // slidesPerView: 1,
        // spaceBetween: 0,
        // centeredSlides: false,

        // loop: false,
        // loopAdditionalSlides: 0,
        speed: 400,

        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
        },
    }

    const swiperCareerSubConfig = {
        // slidesPerView: 7,
        // spaceBetween: 8,
        // freeMode: true,
        // watchSlidesProgress: true,
    }

    const swiperCareerConfig = {
        // effect: 'slide', // slide | fade | cube | coverflow | flip | creative | cards
        // fadeEffect: {
        // 	crossFade: true,
        // },
        // allowTouchMove: true,

        // slidesPerView: 1,
        // spaceBetween: 0,
        // centeredSlides: false,

        // loop: false,
        // loopAdditionalSlides: 0,
        // speed: 300,

        // autoplay: {
        //     delay: 3000,
        // },

        // pagination: {
        // 	el: '.swiper-pagination',
        //     clickable: false,
        //     type: 'bullets' // 'bullets' | 'fraction' | 'progressbar'
        // },

    }

    const swiperConfig = {
        // effect: 'slide', // slide | fade | cube | coverflow | flip | creative | cards
        // fadeEffect: {
        // 	crossFade: true,
        // },
        // allowTouchMove: true,

        // slidesPerView: 1,
        // spaceBetween: 0,
        // centeredSlides: false,

        // loop: false,
        // loopAdditionalSlides: 0,
        // speed: 300,

        // autoplay: {
        //     delay: 3000,
        // },

        // pagination: {
        // 	el: '.swiper-pagination',
        //     clickable: false,
        //     type: 'bullets' // 'bullets' | 'fraction' | 'progressbar'
        // },

        // navigation: {
        // 	prevEl: '.swiper-button-prev',
        // 	nextEl: '.swiper-button-next',
        // },

        // breakpoints: {
        //     768: {
        //     }
        // }
    }

    const swiperHero = new Swiper('.js-swiper-hero', swiperHeroConfig);
    const swiperNews = new Swiper('.js-swiper-news', swiperNewsConfig);
    var swiperCareerSub = new Swiper('.js-swiper-career-sub', {
        allowTouchMove: false,
    });
    var swiperCareer = new Swiper('.js-swiper-career', {
        loop: true,
        loopAdditionalSlides: 1,
        speed: 400,
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
        },
        thumbs: {
            swiper: swiperCareerSub,
        },
    });

    var swiper = new Swiper('.js-swiper-case', {
        slidesPerView: 1,
        loop: true,
        loopAdditionalSlides: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: { // ブレークポイント
            0: { // 画面幅600px以上で適用
                slidesPerView: 1,
                spaceBetween: "31.25vw",
            },
            769: { // 画面幅600px以上で適用
                slidesPerView: 3,
                spaceBetween: "31.25vw",
            },
        },
    });

    // バナースライダー
    const bannerSwiperContainer = document.querySelector('.js-swiper-banner');
    const totalSlides = bannerSwiperContainer ? bannerSwiperContainer.querySelectorAll('.swiper-slide').length : 0;

    var swiperBanner = new Swiper('.js-swiper-banner', {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: false,
        speed: 600,
        autoplay: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
            enabled: totalSlides > 2,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            enabled: totalSlides > 2,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            769: {
                slidesPerView: Math.min(2, totalSlides),
                spaceBetween: 40,
            },
        },
        on: {
            init: function() {
                // 初期化時にページネーションとナビゲーションの表示を制御
                if (totalSlides <= 2) {
                    const pagination = this.pagination.el;
                    const prevBtn = this.navigation.prevEl;
                    const nextBtn = this.navigation.nextEl;

                    if (pagination) pagination.style.display = 'none';
                    if (prevBtn) prevBtn.style.display = 'none';
                    if (nextBtn) nextBtn.style.display = 'none';
                }
            }
        }
    });

    if (document.querySelector('.js-swiper-pause')) {
        document.querySelector('.js-swiper-pause').addEventListener('click', function() {
            if (this.classList.contains('is-started')) {
                swiperHero.autoplay.start();
                this.classList.remove('is-started');
            } else {
                swiperHero.autoplay.stop();
                this.classList.add('is-started');
            }
        });
    }
};

const setupShareButton = () => {
    const shareButtons = document.querySelectorAll('.js-share-button');
    const shareUrl = encodeURIComponent(location.href);
    const shareTitle = encodeURIComponent(document.title);

    shareButtons.forEach((button) => {
        const sns = button.getAttribute('data-sns');
        let url = '';

        switch (sns) {
            case 'facebook':
                url = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
                break;

            case 'x':
                url = `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`;
                break;

            case 'line':
                url = `https://social-plugins.line.me/lineit/share?url=${shareUrl}`;
                break;

            case 'hatena':
                url = `https://b.hatena.ne.jp/add?mode=confirm&url=${shareUrl}&title=${shareTitle}`;
                break;

            default:
                break;
        }

        if (url) {
            button.setAttribute('href', url);
        }
    });
};

const setupUrlCopyButton = () => {
    const copyButtons = document.querySelectorAll('.js-copy-button');
    const copyUrl = location.href;

    copyButtons.forEach((button) => {
        button.addEventListener('click', () => {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(copyUrl).then(() => {
                    alert('URLをコピーしました。');
                }).catch((err) => {
                    alert('URLのコピーに失敗しました。');
                    console.error('Error copying URL: ', err);
                });
            } else {
                alert('このブラウザはクリップボード機能をサポートしていないか、SSL通信でないため、URLのコピーができません。');
            }
        });
    });
}

const setupKnowledgeArchiveCategorySwiper = () => {
    const spMediaQuery = window.matchMedia('(max-width: 768px)');

    document.querySelectorAll('.js-swiper-knowledge-archive-category').forEach((swiperElement) => {
        const category = swiperElement.closest('.knowledge-archive__category');
        if (!category) {
            return;
        }

        const slideCount = Number(category.dataset.slideCount || swiperElement.querySelectorAll('.swiper-slide').length);
        if (slideCount < 2) {
            return;
        }

        const prevButton = category.querySelector('.knowledge-archive__category-nav-prev');
        const nextButton = category.querySelector('.knowledge-archive__category-nav-next');
        const navButtons = category.querySelectorAll('.knowledge-archive__category-nav');
        let swiperInstance = swiperElement.swiper ?? null;

        const shouldEnableSwiper = () => spMediaQuery.matches && slideCount >= 2;

        const updateNavigationVisibility = (isEnabled) => {
            const showNavigation = isEnabled && slideCount > 1;

            navButtons.forEach((button) => {
                button.hidden = !showNavigation;
            });
        };

        const toggleSwiper = () => {
            const isEnabled = shouldEnableSwiper();

            category.classList.toggle('is-swiper-active', isEnabled);
            category.classList.toggle('is-swiper-grid', !isEnabled);
            updateNavigationVisibility(isEnabled);

            if (isEnabled) {
                if (swiperInstance) {
                    return;
                }

                swiperInstance = new Swiper(swiperElement, {
                    slidesPerView: 'auto',
                    spaceBetween: 40,
                    speed: 400,
                    loop: false,
                    navigation: {
                        prevEl: prevButton,
                        nextEl: nextButton,
                    },
                });

                return;
            }

            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        };

        toggleSwiper();
        spMediaQuery.addEventListener('change', toggleSwiper);
    });
};

const setupKnowledgeCaseSwiper = () => {
    const spMediaQuery = window.matchMedia('(max-width: 768px)');

    document.querySelectorAll('.js-swiper-knowledge-cases').forEach((swiperElement) => {
        const section = swiperElement.closest('.knowledge-related-cases');
        if (!section) {
            return;
        }

        const slideCount = Number(section.dataset.slideCount || swiperElement.querySelectorAll('.swiper-slide').length);
        const prevButton = section.querySelector('.knowledge-related-cases__nav-prev');
        const nextButton = section.querySelector('.knowledge-related-cases__nav-next');
        const navButtons = section.querySelectorAll('.knowledge-related-cases__nav');
        let swiperInstance = swiperElement.swiper ?? null;

        const shouldEnableSwiper = () => {
            if (slideCount <= 0) {
                return false;
            }

            if (spMediaQuery.matches) {
                return true;
            }

            return slideCount >= 3;
        };

        const updateNavigationVisibility = (isEnabled) => {
            const showNavigation = isEnabled && slideCount > 1;

            navButtons.forEach((button) => {
                button.hidden = !showNavigation;
            });
        };

        const toggleSwiper = () => {
            const isEnabled = shouldEnableSwiper();

            section.classList.toggle('is-swiper-active', isEnabled);
            section.classList.toggle('is-swiper-grid', !isEnabled && slideCount > 0);
            updateNavigationVisibility(isEnabled);

            if (isEnabled) {
                if (swiperInstance) {
                    return;
                }

                swiperInstance = new Swiper(swiperElement, {
                    slidesPerView: 'auto',
                    spaceBetween: 32,
                    speed: 400,
                    loop: slideCount >= 3,
                    navigation: {
                        prevEl: prevButton,
                        nextEl: nextButton,
                    },
                });

                return;
            }

            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        };

        toggleSwiper();
        spMediaQuery.addEventListener('change', toggleSwiper);
    });
};

export const initInteraction = () => {
    // DOMが完全に読み込まれるまで待つ
    const initFunctions = () => {
        setupClickToggle();
        setupModalToggle();
        setupIndexToggle();
        faqToggle();
        setupSwiper();
        setupKnowledgeCaseSwiper();
        setupKnowledgeArchiveCategorySwiper();
        setupShareButton();
        setupUrlCopyButton();
        caseAccordionToggle();
        caseResetToggle();
    };

    // DOMContentLoadedイベントを待つ
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFunctions);
    } else {
        // 既にDOMが読み込まれている場合
        initFunctions();
    }
};